// IssuesPage.jsx
import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/api";
import "./IssuesPage.css";

const IssuesPage = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showClosed, setShowClosed] = useState(false);

  useEffect(() => {
    fetchWithAuth("/api/report_issues", { method: "GET" })
      .then((data) => {
        console.log("DEBUG: final data is", data);
        setIssues(data);
      })
      .catch((err) => {
        console.error("Failed to fetch issues:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Persist changes immediately
  const saveIssueChanges = async (issueId, fieldName, value) => {
    try {
      // Update local state immediately
      setIssues((prev) =>
        prev.map((issue) =>
          issue.id === issueId ? { ...issue, [fieldName]: value } : issue
        )
      );

      const issue = issues.find((i) => i.id === issueId);
      if (!issue) return;

      // Merge the updated field with the existing data for the request
      const body = {
        status: fieldName === "status" ? value : issue.status,
        updated_comments:
          fieldName === "updated_comments" ? value : issue.updated_comments,
      };

      const updatedIssue = await fetchWithAuth(
        `/api/report_issues/${issueId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );

      console.log("Server returned updated row:", updatedIssue);

      // Replace row with updated one from server
      setIssues((prev) =>
        prev.map((row) => (row.id === issueId ? updatedIssue : row))
      );
    } catch (err) {
      console.error("Failed to update issue:", err);
    }
  };

  if (loading) {
    return <p>Loading issues...</p>;
  }

  const filteredIssues = showClosed
    ? issues
    : issues.filter((issue) => issue.status !== "Closed");

  return (
    <div className="issues-container">
      <h2 className="issues-title">Reported Issues</h2>

      <div className="issues-controls">
        <label className="show-closed-checkbox">
          <input
            type="checkbox"
            checked={showClosed}
            onChange={(e) => setShowClosed(e.target.checked)}
          />
          Show Closed Issues
        </label>
      </div>

      {filteredIssues.length === 0 ? (
        <p className="no-issues-found">No issues found.</p>
      ) : (
        <table className="issues-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Care Home</th>
              <th>Date Created</th>
              <th>Exam Name</th>
              <th>Exam Header</th>
              <th>Question</th>
              <th>Selected Answer</th>
              <th>Comment</th>
              <th>Status</th>
              <th>Date Updated</th>
              <th>Updated Comments</th>
            </tr>
          </thead>
          <tbody>
            {filteredIssues.map((issue) => {
              const createdAtStr = issue.created_at
                ? new Date(issue.created_at).toLocaleString()
                : "";
              const updatedAtStr = issue.updated_at
                ? new Date(issue.updated_at).toLocaleString()
                : "";

              return (
                <tr key={issue.id}>
                  <td>{issue.id}</td>
                  <td>{issue.user_name}</td>
                  <td>{issue.assigned_home}</td>
                  <td>{createdAtStr}</td>
                  <td>{issue.exam_name || ""}</td>
                  <td>{issue.exam_header || ""}</td>
                  <td>{issue.question_text}</td>
                  <td>{issue.selected_answer}</td>
                  <td>{issue.comment}</td>

                  {/* Status dropdown with auto-save */}
                  <td>
                    <select
                      className={
                        issue.status === "Closed"
                          ? "status-closed"
                          : "status-open"
                      }
                      value={issue.status || "Open"}
                      onChange={(e) =>
                        saveIssueChanges(issue.id, "status", e.target.value)
                      }
                    >
                      <option
                        value="Open"
                        style={{
                          backgroundColor: "#e6f4ea",
                          color: "#1b5e20",
                          fontWeight: "bold",
                        }}
                      >
                        Open
                      </option>
                      <option
                        value="Closed"
                        style={{
                          backgroundColor: "#ffebee",
                          color: "#b71c1c",
                          fontWeight: "bold",
                        }}
                      >
                        Closed
                      </option>
                    </select>
                  </td>

                  <td>{updatedAtStr}</td>

                  {/* Updated Comments with auto-save */}
                  <td>
                    <textarea
                      rows={2}
                      cols={15}
                      value={issue.updated_comments || ""}
                      onChange={(e) =>
                        saveIssueChanges(
                          issue.id,
                          "updated_comments",
                          e.target.value
                        )
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default IssuesPage;
